import React from 'react';
import PropTypes from 'prop-types';

import { connect } from "react-redux";
import { patchImageSlider, deleteImageSlider } from 'redux/image-sliders/actions';

import CommonLinkContainer
  from 'components/common/link-elements/CommonLinkContainer';
import CommonImageSliderHeaderContent
  from 'components/dashboard/image-slider/common-slider/CommonImageSliderHeaderContent';
import CommonImageSliderExpandedContent
  from 'components/dashboard/image-slider/common-slider/CommonImageSliderExpandedContent';

import './CommonImageSlider.css';

function CommonImageSlider(props) {
  const { item, patchImageSlider, deleteImageSlider } = props;

  return (
    <div className="common-image-slider__component">
      <CommonLinkContainer
        linkItem={item}
        allowExpand
        patchLinkFunction={patchImageSlider}
        headerContent={
          <CommonImageSliderHeaderContent
            key={`common-image-slider-header-content-key-${item.id}`}
            item={item}
            deleteImageSlider={deleteImageSlider}
          />
        }
        expandedContent={
          <CommonImageSliderExpandedContent
            key={`common-image-slider-expanded-content-key-${item.id}`}
            item={item}
            deleteImageSlider={deleteImageSlider}
            patchImageSlider={patchImageSlider}
          />
        }
      />
    </div>
  );
}

CommonImageSlider.propTypes = {
  patchImageSlider: PropTypes.func.isRequired,
  deleteImageSlider: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default connect(
  null,
  {
    patchImageSlider,
    deleteImageSlider,
  },
)(CommonImageSlider);
